import { useState, useEffect } from 'react'
import { api, ReadinessResponse } from '../lib/api'

export function useReadinessCheck() {
  const [readiness, setReadiness] = useState<ReadinessResponse | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let mounted = true

    async function fetchReadiness() {
      try {
        setIsLoading(true)
        setError(null)
        const data = await api.readiness()
        if (mounted) {
          setReadiness(data)
        }
      } catch (err) {
        if (mounted) {
          setError(err instanceof Error ? err.message : 'Failed to fetch readiness')
        }
      } finally {
        if (mounted) {
          setIsLoading(false)
        }
      }
    }

    fetchReadiness()

    return () => {
      mounted = false
    }
  }, [])

  return { readiness, isLoading, error }
}
